export default __webpack_public_path__ + "static/media/DiscordIcon.71df04cf.svg";